/*
  File name: index.js
    Program Description:
    - This file sets the state values for the pdbnf graph state.
*/
import { getField, updateField } from 'vuex-map-fields'
const getDefaultState = () => {
  return {
    timeFrame: '',
    month: [],
    year: [],
    quarter: [],
    sector: [],
    subsector: [],
    generalCause: [],
    specificCause: [],
    recordType: null,
    notification: null,
    classification: null,
    dbnStatus: [],
    sectorList: [],
    causeList: [],
    recordList: [],
    statusList: [],
    yearItems: [],
    documentType: []
  }
}

const state = getDefaultState()

const mutations = {
  updateField,
  set (state, payload) {
    for (const key in payload) {
      Object.prototype.hasOwnProperty.call(state, key) && (state[`${key}`] = payload[`${key}`])
    }
  },
  reset (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  getField
}

const actions = {
  async set ({ commit }, payload) {
    commit('set', payload)
  },
  async reset ({ commit }) {
    commit('reset')
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
